<prlw-title-logo-ui
  [appearance]="appearance"
  [svgName]="svgName$ | async"
></prlw-title-logo-ui>
